<div>
    <ion-grid>
        <ion-row class="ion-justify-content-center">
            <ion-col size="12" size-xs="12" size-sm="12" size-md="10" size-lg="8" size-xl="6">
                <form [formGroup]="profileForm">
                    <ion-card class="user-profile-card">
                        <ion-card-header>
                            <ion-card-title color="teal" class="section-title"> {{ content?.user?.pages?.profile?.personal?.cardtitle }}</ion-card-title>
                        </ion-card-header>
                        <ion-card-content class="card-content-padding-reduced">
                            <ion-list
                                class="ion-list-div"
                                [ngClass]="{
                                    'invalid-input': profileForm.get('name').hasError('required')
                                }"
                            >
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{ content?.user?.pages?.profile?.personal?.name }}
                                        <p slot="end">
                                            <ion-note
                                                *ngIf="profileForm.get('name').hasError('required') && profileForm.get('name').touched"
                                                slot="end"
                                                color="danger"
                                                class="small-text-warning"
                                            >
                                                {{ content?.user?.pages?.profile?.personal?.namewarning }}</ion-note
                                            >
                                        </p>
                                    </ion-label>
                                    <ion-input type="text" formControlName="name" placeholder="Name"></ion-input>
                                </ion-item>
                                <ion-item class="profile-item-input dob-item ion-padding-start" lines="none">
                                    <ion-label position="stacked">
                                        {{ content?.user?.pages?.profile?.personal?.dob }}
                                        <p slot="end">
                                            <ion-note
                                                *ngIf="profileForm.get('birthday').hasError('required') && profileForm.get('birthday').touched"
                                                slot="end"
                                                color="danger"
                                                class="small-text-warning"
                                            >
                                                {{ content?.user?.pages?.profile?.personal?.dobwarning }}</ion-note
                                            >
                                        </p>
                                    </ion-label>
                                    <div class="date-picker-box">
                                        <input
                                            class="datePicker"
                                            matInput
                                            [max]="maxDate"
                                            [matDatepicker]="pickerBirthday"
                                            placeholder="MM/DD/YYYY"
                                            formControlName="birthday"
                                            class="profile-input profile-datepicker"
                                        />
                                        <mat-datepicker-toggle matSuffix [for]="pickerBirthday"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerBirthday></mat-datepicker>
                                    </div>
                                </ion-item>
                                <ion-item lines="none">
                                    <ion-label position="stacked"> {{ content?.user?.pages?.profile?.personal?.mobile }}</ion-label>
                                    <div>
                                        <amo-phone-country-selection
                                            placeholder="Enter number"
                                            [emititemmodal]="phoneCountry.emititemmodal"
                                            (onInputChange)="listenerPhoneTextAndModel($event, 'phone')"
                                            [display]="phoneCountry.display"
                                            [value]="phoneCountry.valueInputInitial"
                                            class="amo-phone-country"
                                            validcheck="true"
                                        ></amo-phone-country-selection>

                                        <div class="ion-text-center">
                                            <ion-note
                                                *ngIf="profileForm.get('phone').hasError('notUnique')"
                                                slot="end"
                                                color="danger"
                                                class="small-text-warning"
                                            >
                                                {{ content.user?.pages?.profile?.personal?.mobilewarning }}</ion-note
                                            >
                                        </div>
                                        <ion-note *ngIf="profileForm.get('phone').hasError('pattern')" slot="end" color="danger" class="small-text-warning">
                                            Valid country code and phone number required.
                                        </ion-note>
                                        <ion-note
                                            *ngIf="profileForm.get('phone').touched && !noOfDigitsCheck(profileForm.get('phone').value)"
                                            slot="end"
                                            color="danger"
                                            class="small-text-warning"
                                        >
                                            <!-- {{content?.user?.pages?.profile?.personal?.mobilewarning}} -->
                                            Minimum 7 digits required.
                                        </ion-note>
                                        <ion-note
                                            *ngIf="
                                                profileForm.get('phone').touched &&
                                                !profileForm.get('phone').hasError('pattern') &&
                                                noOfDigitsCheck(profileForm.get('phone').value) &&
                                                libphonenumbervalid === false
                                            "
                                            slot="end"
                                            color="warning"
                                            class="profile-input-error-message"
                                        >
                                            <ion-icon name="alert-circle-outline"></ion-icon>

                                            Phone number is not formatted to your country code.
                                        </ion-note>
                                    </div>
                                </ion-item>
                                <ion-item lines="none">
                                    <ion-label position="stacked"> {{ content?.user?.pages?.profile?.personal?.homenumber }}</ion-label>
                                    <div>
                                        <!-- <ion-input type="tel" formControlName="altphone"></ion-input> -->
                                        <amo-phone-country-selection
                                            placeholder="Enter number"
                                            [emititemmodal]="altPhoneCountry.emititemmodal"
                                            (onInputChange)="listenerPhoneTextAndModel($event, 'altphone')"
                                            [display]="altPhoneCountry.display"
                                            [value]="altPhoneCountry.valueInputInitial"
                                            class="amo-phone-country"
                                            validcheck="true"
                                        ></amo-phone-country-selection>

                                        <div class="ion-text-center">
                                            <ion-note
                                                *ngIf="profileForm.get('altphone').hasError('notUnique')"
                                                slot="end"
                                                color="danger"
                                                class="small-text-warning"
                                            >
                                                {{ content?.user?.pages?.profile?.personal?.homenumberwarning }}</ion-note
                                            >
                                        </div>
                                    </div>
                                </ion-item>
                                <ion-item>
                                    <ion-label position="stacked"> {{ content?.user?.pages?.profile?.personal?.countrybirth }}*</ion-label>
                                    <ion-select cancelText="Dismiss" okText="Ok" formControlName="countryofbirth">
                                        <ion-select-option
                                            *ngFor="let country of content?.countries; let i = index; trackBy: trackByIndex"
                                            value="{{ country }}"
                                        >
                                            {{ country }}</ion-select-option
                                        >
                                    </ion-select>
                                </ion-item>
                                <ion-item>
                                    <ion-label position="stacked">
                                        Gender*
                                        <p slot="end">
                                            <ion-note
                                                *ngIf="profileForm.get('gender').hasError('required')"
                                                slot="end"
                                                color="danger"
                                                class="small-text-warning"
                                            >
                                                {{ content?.user?.pages?.profile?.contact?.warning }}</ion-note
                                            >
                                        </p>
                                    </ion-label>
                                    <ion-select okText="Ok" cancelText="Dismiss" formControlName="gender">
                                        <ion-select-option [value]="'Female'">Female</ion-select-option>
                                        <ion-select-option [value]="'Male'">Male</ion-select-option>
                                        <ion-select-option [value]="'Non-Binary'">Non-Binary</ion-select-option>
                                    </ion-select>
                                </ion-item>
                            </ion-list>
                        </ion-card-content>
                    </ion-card>
                </form>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<amo-phone-country-selection-modal
    [emititemtext]="phoneCountry.emititemtext"
    [display]="phoneCountry.display"
    [selectedflaginput]="phoneCountry.selectedflaginput"
    (onInputChange)="listenerPhoneTextAndModel($event, 'phone')"
></amo-phone-country-selection-modal>
<amo-phone-country-selection-modal
    [emititemtext]="altPhoneCountry.emititemtext"
    [display]="altPhoneCountry.display"
    [selectedflaginput]="altPhoneCountry.selectedflaginput"
    (onInputChange)="listenerPhoneTextAndModel($event, 'altphone')"
></amo-phone-country-selection-modal>
